export class ApiEndPoint {
    //Base URL
    authBaseUrl = "https://logistiqauthlive.logistiq.io/";
    masterUrlWithChannelId=(channelId)=>`https://logistiq-masters-prod.logistiq.io/masters/api/v1/channel/${channelId}/`;
    hawkBaseUrl = "https://fm-prod.logistiq.io/api/v1/";
    geckoBaseUrl = "https://shipping.logistiq.io/"
    masterUrl = "https://logistiq-masters-prod.logistiq.io/masters/api/v1/";
    source="FM_DASHBOARD";

    /// user details api url
    userDetailsUrl = "auth/api/v1/accounts/user";
    /// refRes token api url
    refResToken = "auth/api/v1/accounts/token"

    shipping_url = "https://shipping-new.logistiq.io/";

    orderTrackingDetails="ordertracking"

    //FirstMile
    warehouseUrl = "auth/api/v1/warehouses/";
    driverUrl = "driver/drivers";
    countTaskUrl = "task/common-tasks-count";
    commonTaskUrl = "task/common-tasks/";
    assignDriver = "task/assign-driver";
    unassignDriver = "task/unassign-driver";
    orderDetailsUrl = "task/order-details/";
    locationUpdateApiUrl = "auth/api/v1/warehouses/";
    createDriverLocationMappingApiUrl =
        "auth/api/v1/map-driver-location/create-mapping/";
    orderDetails = '#/order/details?awb=';
    getCountry = "auth/api/v1/place/get-country";
    getCityWithOutState = "auth/api/v1/place/get-city-data";
    getPostalCodeNew = "auth/api/v1/place/get-postal-data";
    orderLstApiUrl = "task/manual_task_order_search";
    createManualTaskApiUrl = "task/create-manual-task";
    existingTaskListApiUrl = "task/fetch-manual-task-by-type";
    vendorNameApiUrl = "auth/api/v1/vendor-dropdown";
    addToExistingTaskApiUrl = "task/add-to-manual_task/";
    fmOrderCountApi = "task/manual_task_order_common_count";
    vendorListForFilterApiUrl = "task/manual_task_order_vendor_list";
    cityListForFilterApiUrl = "task/manual_task_order_city_list";
    areaListForFilterApiUrl = "task/manual_task_order_area_list";
    conceptListForFilterApiUrl = "task/manual_task_order_concept_list";
    channel = "channel/";
    assetsLookup = "/assets/lookup";
    downloadTaskApiUrl = "task/download";
}
